import isDebugMode from './isDebugMode';
/**
 * Outputs a debug message if the user has set the cookie MpDebug to true
 *
 * @param namespace
 * @param message
 * @param rest - any data to output
 */
const debugMessage = (namespace: string, message: string, ...rest: any) => {
  if (!isDebugMode()) {
    return;
  }

  // eslint-disable-next-line no-console
  console.debug(`[${namespace}]: ${message}`, ...rest);
};

export default debugMessage;
